import React from 'react'
import { websiteUrl } from '../constants'

export default function PublicPageHeader() {
    return (
        <div className="qpHeaderSection">
            <div className="container">
                <div className="qpHeaderInner">

                    <img
                        className="qpLogo"
                        src="/assets/img/kimboCorpLogo.svg"
                        alt="kimbocorp"
                        onClick={() => window.open(websiteUrl, "_blank")}
                    />

                    <div className="qpStoreButtons">
                        <a
                            href="https://apps.apple.com/us/app/kimbocorp/id6737228466"
                            target="_blank"
                        >
                            <img src="assets/img/landingPage/applestore.svg" alt="" />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=io.kimbocorp"
                            target="_blank"
                        >
                            <img src="assets/img/landingPage/playstore.svg" alt="" />
                        </a>
                    </div>

                </div>
            </div>
        </div>
    )
}
